import React, { useContext, useState } from "react";
import Modal from "react-modal/lib/components/Modal";
import { ContextRegisterCollaborator } from "../context";
import reqEMail from "../../../../services/reqEMail/reqEMail";
import { handleMessageError, handleMessageSuccess } from "../../../toast";
import LockResetIcon from "@mui/icons-material/LockReset";
import "./style.css";

export const ModalRecoveryCollaborator = () => {
	const {
		isOpenModalRecoveryCollaborator,
		closeModalRecoveryCollaborator,
		collaboratorRecovery,
	} = useContext(ContextRegisterCollaborator);

	const [loading, setLoading] = useState(false);

	const handleSendRecovery = async () => {
		try {
			setLoading(true);
			const body = {
				email_destino: collaboratorRecovery.email,
				assunto: "Redefinir senha",
				mensagem: "",
			};

			const response = await reqEMail.sendEMail(body);

			if (response.status === 200) {
				handleMessageSuccess("E-mail de recuperação enviado com sucesso!");
				closeModalRecoveryCollaborator();
			} else {
				throw new Error("Erro ao enviar e-mail");
			}
		} catch (error) {
			console.error(error);
			handleMessageError(error.message || "Erro ao enviar e-mail de recuperação.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			isOpen={isOpenModalRecoveryCollaborator}
			onRequestClose={closeModalRecoveryCollaborator}
			overlayClassName="recovery-modal-overlay"
			className="recovery-modal-content"
			shouldCloseOnOverlayClick={true}
		>
			<div className="recovery-icon-container">
				<LockResetIcon sx={{ fontSize: 32 }} />
			</div>

			<h3 className="recovery-modal-title">Redefinir Senha</h3>

			<p className="recovery-modal-text">
				Deseja enviar um link de redefinição para o colaborador{" "}
				<span className="font-bold text-slate-800">{collaboratorRecovery.nome}</span>?
				<br />
				<span className="recovery-email-badge">{collaboratorRecovery.email}</span>
			</p>

			<div className="recovery-footer-actions">
				<button
					className="btn-premium-cancel"
					type="button"
					onClick={closeModalRecoveryCollaborator}
					disabled={loading}
				>
					Agora não
				</button>
				<button
					className="btn-premium-send"
					type="button"
					disabled={loading}
					onClick={handleSendRecovery}
				>
					{loading ? (
						<span className="spinner-border spinner-border-sm" role="status"></span>
					) : (
						"Enviar link"
					)}
				</button>
			</div>
		</Modal>
	);
};

